module.exports = __webpack_public_path__ + "img/ikon-en_l.2c5075b2.png";